<template>
  <nav class="navbar navbar-expand bg-body-tertiary">
    <div class="container-fluid">

      <ul class="navbar-nav  mx-auto">
        <li class="nav-item">
          <router-link to="/about" class="nav-link site-links"><div class="site-link-text">About</div></router-link>
        </li>
        <li class="nav-item">
          <router-link to="/privacy" class="nav-link site-links"><div class="site-link-text">Privacy</div></router-link>
        </li>
        <li class="nav-item">
          <router-link to="/contact-us" class="nav-link site-links"><div class="site-link-text">Reach<br>Out</div></router-link>
        </li>
        <li class="nav-item">
          <div class="nav-link social-links">
            <a href="https://www.facebook.com/profile.php?id=61575557296306" title='Facebook' target='blank'>
              <svg class="social-media-logo" viewBox="0 0 500 500">
                <path class="fill-color" id="Initiator" d="M500,250C500,111.93,388.07,0,250,0S0,111.93,0,250c0,117.24,80.72,215.62,189.61,242.64v-166.24h-51.55v-76.4h51.55v-32.92c0-85.09,38.51-124.53,122.05-124.53,15.84,0,43.17,3.11,54.35,6.21v69.25c-5.9-.62-16.15-.93-28.88-.93-40.99,0-56.83,15.53-56.83,55.9v27.02h81.66l-14.03,76.4h-67.63v171.77c123.79-14.95,219.71-120.35,219.71-248.17Z"/>
                <path class="no-fill" id="F" d="M347.92,326.4l14.03-76.4h-81.66v-27.02c0-40.37,15.84-55.9,56.83-55.9,12.73,0,22.98.31,28.88.93v-69.25c-11.18-3.11-38.51-6.21-54.35-6.21-83.54,0-122.05,39.44-122.05,124.53v32.92h-51.55v76.4h51.55v166.24c19.34,4.8,39.57,7.36,60.39,7.36,10.25,0,20.36-.63,30.29-1.83v-171.77h67.63Z"/>
              </svg>
            </a>
            <span class="social-spacer"></span>
            <a href="https://x.com/myOscarList" title='X' target='blank'>
              <svg class="social-media-logo" viewBox="0 0 1200 1227">
                <path class="fill-color" d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="black"/>
              </svg>
            </a>
            <span class="social-spacer"></span>
            <a href="https://www.instagram.com/myoscarlist/" title='Instagram' target='blank'>
              <svg class="social-media-logo" viewBox="0 0 1000 1000">
                <path class="fill-color" d="M295.42,6c-53.2,2.51-89.53,11-121.29,23.48-32.87,12.81-60.73,30-88.45,57.82S40.89,143,28.17,175.92c-12.31,31.83-20.65,68.19-23,121.42S2.3,367.68,2.56,503.46,3.42,656.26,6,709.6c2.54,53.19,11,89.51,23.48,121.28,12.83,32.87,30,60.72,57.83,88.45S143,964.09,176,976.83c31.8,12.29,68.17,20.67,121.39,23s70.35,2.87,206.09,2.61,152.83-.86,206.16-3.39S799.1,988,830.88,975.58c32.87-12.86,60.74-30,88.45-57.84S964.1,862,976.81,829.06c12.32-31.8,20.69-68.17,23-121.35,2.33-53.37,2.88-70.41,2.62-206.17s-.87-152.78-3.4-206.1-11-89.53-23.47-121.32c-12.85-32.87-30-60.7-57.82-88.45S862,40.87,829.07,28.19c-31.82-12.31-68.17-20.7-121.39-23S637.33,2.3,501.54,2.56,348.75,3.4,295.42,6m5.84,903.88c-48.75-2.12-75.22-10.22-92.86-17-23.36-9-40-19.88-57.58-37.29s-28.38-34.11-37.5-57.42c-6.85-17.64-15.1-44.08-17.38-92.83-2.48-52.69-3-68.51-3.29-202s.22-149.29,2.53-202c2.08-48.71,10.23-75.21,17-92.84,9-23.39,19.84-40,37.29-57.57s34.1-28.39,57.43-37.51c17.62-6.88,44.06-15.06,92.79-17.38,52.73-2.5,68.53-3,202-3.29s149.31.21,202.06,2.53c48.71,2.12,75.22,10.19,92.83,17,23.37,9,40,19.81,57.57,37.29s28.4,34.07,37.52,57.45c6.89,17.57,15.07,44,17.37,92.76,2.51,52.73,3.08,68.54,3.32,202s-.23,149.31-2.54,202c-2.13,48.75-10.21,75.23-17,92.89-9,23.35-19.85,40-37.31,57.56s-34.09,28.38-57.43,37.5c-17.6,6.87-44.07,15.07-92.76,17.39-52.73,2.48-68.53,3-202.05,3.29s-149.27-.25-202-2.53m407.6-674.61a60,60,0,1,0,59.88-60.1,60,60,0,0,0-59.88,60.1M245.77,503c.28,141.8,115.44,256.49,257.21,256.22S759.52,643.8,759.25,502,643.79,245.48,502,245.76,245.5,361.22,245.77,503m90.06-.18a166.67,166.67,0,1,1,167,166.34,166.65,166.65,0,0,1-167-166.34" transform="translate(-2.5 -2.5)"/>
              </svg>
            </a>
<!--
            <span class="social-spacer"></span>
            <a href="https://discord.gg/gAcRJZpvxq" title='Discord' target='blank'>
              <svg class="social-media-logo" viewBox="0 0 126.644 96">
                <path class="fill-color" d="M81.15,0c-1.2376,2.1973-2.3489,4.4704-3.3591,6.794-9.5975-1.4396-19.3718-1.4396-28.9945,0-.985-2.3236-2.1216-4.5967-3.3591-6.794-9.0166,1.5407-17.8059,4.2431-26.1405,8.0568C2.779,32.5304-1.6914,56.3725.5312,79.8863c9.6732,7.1476,20.5083,12.603,32.0505,16.0884,2.6014-3.4854,4.8998-7.1981,6.8698-11.0623-3.738-1.3891-7.3497-3.1318-10.8098-5.1523.9092-.6567,1.7932-1.3386,2.6519-1.9953,20.281,9.547,43.7696,9.547,64.0758,0,.8587.7072,1.7427,1.3891,2.6519,1.9953-3.4601,2.0457-7.0718,3.7632-10.835,5.1776,1.97,3.8642,4.2683,7.5769,6.8698,11.0623,11.5419-3.4854,22.3769-8.9156,32.0509-16.0631,2.626-27.2771-4.496-50.9172-18.817-71.8548C98.9811,4.2684,90.1918,1.5659,81.1752.0505l-.0252-.0505ZM42.2802,65.4144c-6.2383,0-11.4159-5.6575-11.4159-12.6535s4.9755-12.6788,11.3907-12.6788,11.5169,5.708,11.4159,12.6788c-.101,6.9708-5.026,12.6535-11.3907,12.6535ZM84.3576,65.4144c-6.2637,0-11.3907-5.6575-11.3907-12.6535s4.9755-12.6788,11.3907-12.6788,11.4917,5.708,11.3906,12.6788c-.101,6.9708-5.026,12.6535-11.3906,12.6535Z"/>
              </svg>
            </a>
-->
            <span class="social-spacer"></span>
            <a href="https://letterboxd.com/myOscarList/" title='Letterboxd' target='blank'>
              <svg class="social-media-logo" viewBox="0 0 500 500">
                <path class="fill-color" d="M250,0C111.93,0,0,111.93,0,250s111.93,250,250,250,250-111.93,250-250S388.07,0,250,0ZM368.92,320c-25.09,0-47.08-13.17-59.46-32.97-12.38,19.79-34.38,32.97-59.46,32.97s-47.08-13.17-59.46-32.97c-12.38,19.79-34.38,32.97-59.46,32.97-38.7,0-70.08-31.34-70.08-70s31.38-70,70.08-70c25.09,0,47.08,13.17,59.46,32.97,12.38-19.79,34.38-32.97,59.46-32.97s47.08,13.17,59.46,32.97c12.38-19.79,34.38-32.97,59.46-32.97,38.7,0,70.08,31.34,70.08,70s-31.38,70-70.08,70Z"/>
                <path class="fill-color" d="M190.54,287.06c-6.73-10.75-10.62-23.45-10.62-37.06s3.89-26.31,10.62-37.06c6.73,10.75,10.62,23.45,10.62,37.06s-3.89,26.31-10.62,37.06h0Z"/>
                <path class="fill-color" d="M309.46,212.94c6.73,10.75,10.62,23.45,10.62,37.06s-3.89,26.31-10.62,37.06c-6.73-10.75-10.62-23.45-10.62-37.06s3.89-26.31,10.62-37.06h0Z"/>
              </svg>
            </a>

            <span class="social-spacer"></span>
            <a href="https://myoscarlist.blogspot.com/" title='Blogger' target='blank'>
              <svg class="social-media-logo" viewBox="0 0 143.6 143.4">
                <path class="fill-color" d="M143.6,69.8c-.1-58.3.1-52.9-2.4-57.8-3.1-6.2-8.4-10.3-15.3-11.7C123.5-.2,19.3,0,17,.4,8.9,2.2,2.6,8.3.6,16.2,0,18.4,0,19.6,0,71.8c0,52.5,0,53.3.6,55.5.6,2.1,2,5.2,3.2,7,1,1.5,3.6,4,5.4,5.3,2.1,1.5,4.5,2.5,7.1,3.2,2,.5,4.6.5,55.2.6,52.3,0,53.1,0,55.4-.6,9-2.3,15.3-9.3,16.4-18.4.2-1.9.3-17.5.2-54.6ZM116.1,79.8c-.1,12.3-.2,13.3-.7,15.4-1.4,5-3.6,8.8-7,12.3-4.7,4.8-9.8,7.4-16.3,8.3-3.7.5-39.9.4-42.9-.2-6.2-1.1-12.3-5.1-16.5-10.5-2.2-2.9-3.2-4.9-4.3-8.2-1.3-4-1.4-6.9-1.3-27.1.1-16.1.2-18.9.6-20.6,2.3-9.3,8.5-16.6,17.1-20,4.7-1.9,7.7-2.1,21.5-2,8.8.1,11.4.2,12.6.6,4.9,1.5,9.2,4.1,13,8,5.4,5.5,8.1,11.6,8.1,18.1,0,3.4.6,4.7,2.6,5.9,1.3.7,1.7.8,5.7,1,2.4.1,4.6.3,5,.5,1.1.6,2.1,2.1,2.5,3.7.2,1.1.3,5.4.2,14.7Z"/>
                <path class="fill-color" d="M54.1,60.6c-3.3-.9-4.5-5.6-2.1-8.1,1.5-1.6,2-1.6,11.7-1.6s9,0,10.3.7c1.8.9,2.7,2.3,2.7,4.3s-.8,3.2-2.4,4.3c-.9.6-1.4.6-10,.7-5.3,0-9.5,0-10.1-.2ZM53.6,92.4c-1.4-.6-2.7-2.3-3-3.9-.2-1.4.5-3.4,1.6-4.4,1.4-1.3,2-1.3,19.3-1.3,17.8,0,17.7,0,19.4,1.6,2.4,2.2,1.9,6.2-1,7.8l-2.9.5-15.4.2c-13.5.2-17.3,0-18-.4Z"/>
              </svg>
            </a>

          </div>
        </li>
      </ul>

    </div>
  </nav>
</template>


<script>
export default {
  name: "FooterBar",
  data() {
    return {
    }
  },
}
</script>


<style>
* {
  --mol-footerbar-bottom-padding: max(12px, env(safe-area-inset-bottom));
  --mol-footerbar-height: calc(3.375em + var( --mol-footerbar-bottom-padding));
}
</style>

<style scoped>

  .navbar {
    height: var(--mol-footerbar-height);
    border-top-style: solid;
    border-top-color: var(--bs-secondary);
    border-top-width: 1px;
    padding-top: 12px;
    padding-bottom: var(--mol-footerbar-bottom-padding);
  }

  .navbar-nav {
    padding-left: 10px;
    padding-right: 10px;
  }

  .nav-item {
    display: inline-block;
  }

  .nav-link {
    /*font-size: small;*/
    height: 3em;
    display: flex;
    align-items: center;

    .site-link-text {
      display: block;
      font-size: small;
    /*  font-weight: 500;*/
      text-align: center;

      line-height: 105%;

    }

  }


  .social-links {
    a {
      display: inline-block;
    }
    .social-spacer {
      display: inline-block;
      width: 0.5rem;
    }
  }

  .social-media-logo {
    margin-top: 0.3em;
    vertical-align: baseline;
    height: 1.05em;
  }

  .no-fill {
    fill:  none;
  }

  .fill-color {
    fill: var(--bs-nav-link-color);
  }
  .stroke-color {
    stroke: var(--bs-nav-link-color);
  }

  a:hover {
    .fill-color {
      fill: var(--bs-nav-link-hover-color);
    }
    .stroke-color {
      stroke: var(--bs-nav-link-hover-color);
    }
  }



</style>